import { render, staticRenderFns } from "./item-title.vue?vue&type=template&id=7fdcc1e2&scoped=true&"
import script from "./item-title.vue?vue&type=script&lang=ts&"
export * from "./item-title.vue?vue&type=script&lang=ts&"
import style0 from "./item-title.vue?vue&type=style&index=0&id=7fdcc1e2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdcc1e2",
  null
  
)

export default component.exports